/** @deprecated use DateTime from graphql-scalars instead. Don't need to import it. */
export const DateTimeType = `scalar GraphQLDateTime`;
